module.exports = __webpack_public_path__ + "img/3.e9117b1d.jpg";